// searchform
// Show/Hide Label on Searchforms
//
// Author: tobias.wolf@wagnerwagner.de


(function () {
  function Searchform(element) {
    const searchElement = element.querySelector('input[type="search"]');
    const submitElement = element.querySelector('input[type="submit"]');
    const labelElement = element.querySelector('.invisible');
    let isSearchform_header;
    let submitClicked = false;

    function init() {
      isSearchform_header = element.classList.contains('searchform_header');
      showLabel();
    }
    function show() {
      bodyElement.classList.add('searchform-is-focused');
      // focus if not focused, this is the case when click event is fired by showSearchElement
      if (document.activeElement !== searchElement) {
        searchElement.focus();
      }
      window.addEventListener('keydown', handleKeydown);
    }
    function hide() {
      bodyElement.classList.remove('searchform-is-focused');
    }
    function showLabel() {
      if (searchElement.value.length === 0) {
        labelElement.classList.add('is-visible');
      }
    }
    function hideLabel() {
      labelElement.classList.remove('is-visible');
    }
    function handleFocus() {
      hideLabel();
      if (isSearchform_header) {
        show();
      }
    }
    function handleClick(e) {
      submitClicked = true;
      if (searchElement.value.length === 0) {
        e.preventDefault();
      }
    }
    function handleBlur() {
      // wait for handleClick()
      setTimeout(() => {
        if (submitClicked) {
          searchElement.focus();
        } else {
          if (searchElement.value.length === 0) {
            showLabel();
          }
          if (isSearchform_header) {
            hide();
          }
        }
        submitClicked = false;
      }, 50);
    }
    function handleKeydown(e) {
      if (e.keyCode === 27) { // esc
        hide();
      }
    }

    searchElement.addEventListener('focus', handleFocus);
    submitElement.addEventListener('click', handleClick);
    searchElement.addEventListener('blur', handleBlur);

    init();

    this.isSearchform_header = isSearchform_header;
    this.show = show;
    this.hide = hide;
  }

  // elements
  var bodyElement = document.querySelector('body');
  const elements = document.querySelectorAll('.searchform');
  let searchform_header;
  const showSearchElement = document.querySelector('.show-search');

  // functions
  function showSearchform_header() {
    searchform_header.show();
  }

  // event listeners
  if (showSearchElement) {
    showSearchElement.addEventListener('click', showSearchform_header);
  }

  // init instances
  if (elements) {
    for (let i = 0; i < elements.length; i++) {
      const searchform = new Searchform(elements[i]);
      if (searchform.isSearchform_header) {
        searchform_header = searchform;
      }
    }
  }
}());
